import { UnreadCountState, UnreadCountAction } from '@types';

export const unreadCountReducer = (state: UnreadCountState = { unreadCount: 0 }, action: UnreadCountAction): UnreadCountState => {
    switch (action.type) {
        case 'SET_INITIAL_UNREAD_COUNT':
            return { ...state, unreadCount: action.payload };
        case 'DECREMENT_UNREAD_COUNT':
            return { ...state, unreadCount: Math.max(state.unreadCount - 1, 0) };
        default:
            return state;
    }
};
